/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

class Cart extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('[name="updates[]"]').forEach(input =>
      input.addEventListener('change', () =>
        this.change(input.dataset.lineItemKey, Number(input.value))
      )
    )

    this.querySelectorAll('.btn-line-item-remove').forEach(btn =>
      btn.addEventListener('click', () =>
        this.change(btn.dataset.lineItemKey, 0)
      )
    )

 

    this.showOffcanvasIfUrl()
    this.adjustCollapses()
  }

  async add (formData) {
    formData.append('sections', ['cart-count-badge', 'offcanvas-cart'])
    formData.append('sections_url', window.location.pathname)

    const response = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
      method: 'POST',
      body: formData
    })
    console.log(response)
    const data = await response.json()
    console.log(data)

    if (response.ok) {
      window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data }))
      this.reloadCartElements(data.sections)
    } else {
      this.showError(data.description)
    }

    document.querySelectorAll('.offcanvas').forEach(offcanvas => {
      if (offcanvas.id === 'offcanvas-cart') {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show()
      } else {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).hide()
      }
    })
  }

  async change (id, quantity) {
    this.classList.add('loading')

    const response = await fetch(`${window.Shopify.routes.cart_change_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id,
        quantity,
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      })
    })
    console.log(response)
    const data = await response.json()
    console.log(data)

    if (response.ok) {
      window.dispatchEvent(new CustomEvent('kt.cart.changed', { detail: data }))
      this.reloadCartElements(data.sections)
    } else {
      this.showError(data.description)
    }

    this.classList.remove('loading')
  }

  reloadCartElements (sections) {
    for (const [key, value] of Object.entries(sections)) {
      const newDoc = new DOMParser().parseFromString(value, 'text/html')

      switch (key) {
      case 'cart-count-badge':
        document.querySelectorAll('.cart-count-badge').forEach(elem => {
          const newDoc = new DOMParser().parseFromString(value, 'text/html')
          elem.replaceWith(newDoc.querySelector('.cart-count-badge'))
        })
        break
      case 'offcanvas-cart':
        this.replaceWith(newDoc.querySelector('cart-container'))
        break
      }
    }

    window.dispatchEvent(new CustomEvent('kt.cart.reloaded'))
  }

  showError (message) {
    const alert = this.querySelector('.alert')

    if (alert) {
      alert.querySelector('[data-alert-msg]').innerHTML = message
      alert.removeAttribute('hidden')
    }
  }

  showOffcanvasIfUrl () {
    if (new URLSearchParams(window.location.search).has('cart')) {
      const offcanvas = document.querySelector('#offcanvas-cart')

      if (offcanvas) {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show()
      }
    }
  }

  adjustCollapses () {
    this.querySelectorAll('[data-bs-toggle="collapse"]').forEach(elem => {
      elem.addEventListener('click', () => {
        setTimeout(() => {
          const offcanvasBody = this.querySelector('.offcanvas-body')
          offcanvasBody.scroll({ top: offcanvasBody.scrollHeight, behavior: 'smooth' })
        }, 250)
      })
    })
  }

  /* AJOUT UPSSELL : Nouvelle méthode pour ajouter un upsell */
  async addUpsell (variantId) {
    const btn = this.querySelector(`[data-variant-id="${variantId}"]`)
    const originalHTML = btn.innerHTML // Stocker le HTML original (avec l'icône SVG)
    btn.classList.add('loading')
    btn.innerHTML = 'Ajout...'

    const formData = new FormData()
    formData.append('id', variantId)
    formData.append('quantity', 1)
    formData.append('sections', ['cart-count-badge', 'offcanvas-cart'])
    formData.append('sections_url', window.location.pathname)

    try {
      const response = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
        method: 'POST',
        body: formData
      })
      const data = await response.json()

      if (response.ok) {
        window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: data }))
        this.reloadCartElements(data.sections)
        btn.innerHTML = '✓ Ajouté'
        setTimeout(() => {
          btn.innerHTML = originalHTML // Remettre l'icône SVG originale
          btn.classList.remove('loading')
        }, 2000)
      } else {
        this.showError(data.description)
        btn.innerHTML = 'Erreur'
        setTimeout(() => {
          btn.innerHTML = originalHTML // Remettre l'icône SVG originale en cas d'erreur aussi
          btn.classList.remove('loading')
        }, 2000)
      }
    } catch (error) {
      console.error('Erreur lors de l\'ajout à l\'upsell:', error)
      btn.innerHTML = 'Réessayer'
      setTimeout(() => {
        btn.innerHTML = originalHTML // Remettre l'icône SVG originale
        btn.classList.remove('loading')
      }, 2000)
    }
  }
  /* FIN AJOUT UPSSELL */
}
customElements.define('cart-container', Cart)

class CartNote extends HTMLElement {
  constructor () {
    super()

    this.input = this.querySelector('textarea')
    this.btn = this.querySelector('button')
    this.btn.addEventListener('click', this.onSubmit.bind(this))
  }

  async onSubmit () {
    this.btn.classList.add('loading')

    await fetch(`${window.Shopify.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: this.input.value })
    })

    this.btn.innerHTML = `✓ <span class="visually-hidden">${this.btn.dataset.textNoteSaved}</span>`

    setTimeout(() => {
      this.btn.innerHTML = this.btn.dataset.textBtnSave
    }, 3000)

    this.btn.classList.remove('loading')
  }
}
customElements.define('cart-note', CartNote)


document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.product-card');
  const topSections = ['.card-top'];
  const bottomSections = ['.card-bottom'];

  // Fonction pour égaliser les hauteurs des parties
  function equalizeHeights() {
    // Égaliser la partie supérieure
    topSections.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      let maxHeight = 0;
      elements.forEach(el => {
        el.style.height = 'auto';
        maxHeight = Math.max(maxHeight, el.offsetHeight);
      });
      elements.forEach(el => {
        el.style.height = maxHeight + 'px';
      });
    });

    // Égaliser la partie inférieure
    bottomSections.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      let maxHeight = 0;
      elements.forEach(el => {
        el.style.height = 'auto';
        maxHeight = Math.max(maxHeight, el.offsetHeight);
      });
      elements.forEach(el => {
        el.style.height = maxHeight + 'px';
      });
    });

    // Égaliser la hauteur totale des cartes (optionnel)
    let maxCardHeight = 0;
    cards.forEach(card => {
      card.style.height = 'auto';
      maxCardHeight = Math.max(maxCardHeight, card.offsetHeight);
    });
    cards.forEach(card => {
      card.style.height = maxCardHeight + 'px';
    });
  }

  // Exécuter au chargement
  equalizeHeights();

  // Utiliser ResizeObserver pour recalculer automatiquement
  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(debounce(equalizeHeights, 100));
    cards.forEach(card => resizeObserver.observe(card));
  } else {
    // Fallback
    window.addEventListener('resize', debounce(equalizeHeights, 100));
  }

  // Fonction debounce
  function debounce(func, delay) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(func, delay);
    };
  }
});


// Fonction pour scroller le carousel
function scrollCarousel(direction) {
  const carousel = document.querySelector('.upsell-carousel');
  if (carousel) {
    const itemWidth = 200; // Largeur d'un item réduite (doit correspondre à flex: 0 0 200px dans le CSS)
    carousel.scrollBy({ left: direction * itemWidth, behavior: 'smooth' });
  }
}

// Fonction pour rendre le carousel dynamique avec scroll automatique
function autoScrollCarousel() {
  const carousel = document.querySelector('.upsell-carousel');
  if (carousel) {
    const itemWidth = 200;
    const totalItems = carousel.children.length;
    let currentIndex = 0;

    setInterval(() => {
      currentIndex = (currentIndex + 1) % totalItems;
      carousel.scrollTo({ left: currentIndex * itemWidth, behavior: 'smooth' });
    }, 3000); // Scroll toutes les 3 secondes
  }
}

// Initialiser le scroll automatique quand le DOM est chargé
document.addEventListener('DOMContentLoaded', autoScrollCarousel);